'use client';
import React from 'react';
import ShareholderStructure from './ShareholderStructure';
import SharePrice from './SharePrice';
import GeneralShareholdersMeeting from './GeneralShareholdersMeeting';
import { classes } from './utils';

export default function Page() {
  return (
    <div className={classes.wrapper}>
      <ShareholderStructure />
      <SharePrice />
      <GeneralShareholdersMeeting />
    </div>
  );
}
